<script lang="ts">
  import { fade } from "svelte/transition";
  import Carousel from "svelte-carousel";
  import { onMount } from "svelte";
  import { onDestroy } from "svelte";
  import LastSlide from "./lastSlide.svelte";
  import WheelListener from "./wheelListener.svelte";

  export let currentPage;
  export let data;

  export let currentSlide;

  export let carousel;
  export let lastSlideData;
//console.log(data,data[currentSlide]?.textColor?.color[0], 'data')
  function handleWheel(event) {
    callBack(event);
  }

  const callBack = throttle(function (event) {
    if (currentSlide === data?.length - 1) {
      return;
    }
    if (event.deltaY < 0) {
      if (currentSlide === 0) {
        currentPage = "startSlide";
        return;
      }
      carousel.goToPrev();
    } else if (event.deltaY > 0) {
      carousel.goToNext();
    }
  }, 1000);

  // onMount(() => {
  //   window.addEventListener("wheel", callBack);
  // });

  // onDestroy(() => {
  //   window.removeEventListener("wheel", callBack);
  // });

  function throttle(fn, wait) {
    var time = Date.now();
    return function (e) {
      if (time + wait - Date.now() < 0) {
        fn(e);
        time = Date.now();
      }
    };
  }
</script>

<WheelListener onWheel={handleWheel} />

<div class="slider-background">
  <Carousel
    dots={false}
    arrows={false}
    bind:this={carousel}
    infinite={false}
    on:pageChange={(event) => (currentSlide = event.detail)}
  >
    {#each data as element, i}
      {#if i === data?.length - 1}
        <img
          class="background-image"
          style="opacity:0.3"
          src={lastSlideData?.backgroundImage[0]?.url}
        />
      {:else}
        <img class="background-image" src={element?.backgroundImage[0]?.url} />
      {/if}
    {/each}
  </Carousel>
</div>

<div class="mid-slides-container p-4 p-sm-5">
  <div>
    {#if currentSlide !== data?.length - 1}
      {#key currentSlide}
        <h1
          class="title is-4"
          style={`color:${
            JSON.parse(data[currentSlide]?.textColor?.color?.[0] ?? "{}")?.color
          };`}
          in:fade={{ delay: 500 }}
          out:fade={{ duration: 200 }}
        >
          {@html data[currentSlide]?.heading}
        </h1>
        <p
          style={`color:${
            JSON.parse(data[currentSlide]?.textColor?.color?.[0] ?? "{}")?.color
          };`}
          in:fade={{ delay: 900 }}
          out:fade={{ duration: 200 }}
        >
          {@html data[currentSlide]?.subText}
        </p>
      {/key}
    {:else}
      <div in:fade={{ delay: 500 }} out:fade={{ duration: 200 }}>
        <LastSlide data={lastSlideData} />
      </div>
    {/if}
  </div>
  <div class="prev-next-btns-container">
    <div
      on:click={() => {
        carousel.goToPrev();
      }}
      class="thumbnail-button button is-line is-white is-right rotate"
      class:invisible={currentSlide === 0}
    >
      <img src={data[currentSlide - 1]?.backgroundImage[0]?.url} />
    </div>
    {#if currentSlide === data?.length - 1}
      <div
        on:click={() => {
          currentPage = "startSlide";
        }}
        class="btn t-sm-18"
      >
        CLOSE
      </div>
    {:else}
      <div
        on:click={() => {
          carousel.goToNext();
        }}
        class="thumbnail-button button is-line is-white is-right"
      >
        <img src={data[currentSlide + 1]?.backgroundImage[0]?.url} />
      </div>
    {/if}
  </div>
</div>

<style>
  .slider-background {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
  .mid-slides-container {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: space-between;
    flex-direction: column;
  }
  .mid-slides-container > div:nth-of-type(1) {
    overflow: auto;
    height: 100%;
  }
  .mid-slides-container > div > *:not(div) {
    max-width: 492px;
  }
  .mid-slides-container .prev-next-btns-container {
    display: flex;
    justify-content: space-between;
  }
  h1.title {
    margin-top: 169px;
    margin-bottom: 40px;
  }
  .background-image {
    object-fit: cover;
    width: 100vw;
    height: 100vh;
    background: linear-gradient(
      180deg,
      rgba(1, 45, 91, 1) 0%,
      rgba(5, 23, 43, 1) 46.3%,
      rgba(1, 45, 91, 1) 100%
    );
  }
  .thumbnail-button.button {
    padding: 0;
    width: 159px;
    min-width: 0px;
    background-color: white;
    border: 0;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    overflow: hidden;
  }
  .thumbnail-button.button::before,
  .thumbnail-button.button::after {
    color: #000;
  }
  .button img {
    object-fit: cover;
    width: 86px;
    height: 58px;
  }
  .rotate {
    transform: rotateZ(180deg);
  }
  .rotate img {
    transform: rotateZ(180deg);
  }
  .btn {
    border: 1px solid white;
    background-color: white;
    color: #032243;
    border-radius: 6px;
    cursor: pointer;
    padding: 7px 15px;
    font-weight: bold;
    transition: all 0.3s;
    display: flex;
    align-items: center;
  }
  .btn:hover {
    opacity: 0.7;
  }
  @media (max-width: 768px) {
    p {
      font-size: 1.2rem;
    }
  }
</style>
